import * as AgGrid from "ag-grid-community";
import * as datasource from "grid/datasource";
import * as gridUtils from "grid/utils";

import {
  ACTIONS_COL_DEF,
  DATE_FILTER_UNTIL_NOW_COL_DEF,
  DEFAULT_COL_DEF,
  TEXT_FILTER_COL_DEF,
} from "../../grid/columns";
import { GridController } from "grid/grid_controller";

interface Report {
  upload_name: string;
  upload_date: string;
}
export default class extends GridController<Report> {
  override buildGrid() {
    const { i18nJson, paginationPageSize } = this.gridTarget.dataset;

    const colDefs: AgGrid.ColDef[] = [
      { field: "upload_name", ...DEFAULT_COL_DEF, ...TEXT_FILTER_COL_DEF, sortable: true },
      {
        field: "upload_date",
        ...DEFAULT_COL_DEF,
        ...DATE_FILTER_UNTIL_NOW_COL_DEF,
        maxWidth: 300,
        sortable: true,
        sort: "desc",
      },
      { ...ACTIONS_COL_DEF },
    ];

    const dataSource = new datasource.Datasource({ callbacks: {}, limit: paginationPageSize });

    const options: AgGrid.GridOptions<Report> = {
      ...gridUtils.DEFAULT_GRID_OPTIONS,
      cacheBlockSize: parseInt(paginationPageSize),
      columnDefs: gridUtils.buildColumnDefs(colDefs, { i18n: JSON.parse(i18nJson) }),
      datasource: dataSource,
    };

    const gridApi = AgGrid.createGrid(this.gridTarget, options);
    dataSource.gridApi = gridApi;

    return gridApi;
  }
}
